import React from "react";
import styled from "styled-components";
import { CencosudCuponImg } from "../../../images";

export const CencosudCupon = () => {
    return (
        <Container>
            <a
                href="https://jbiene.cobiene.com/discount-codes-requests/register"
                target="_blank"
            >
                <img src={CencosudCuponImg} alt="Banner de cupones cencosud" />
            </a>
        </Container>
    );
};

const Container = styled.div`
  margin-top: 2rem;
  img {
    width: 100%;
  }
`;
